import React, { useState } from 'react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Mail } from 'lucide-react';
import { toast } from '../hooks/use-toast';
import { subscribeNewsletter } from '../services/api';

const Newsletter = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (email) {
      setLoading(true);
      try {
        await subscribeNewsletter({
          first_name: 'Guest',
          last_name: 'User',
          email: email
        });
        toast({
          title: "Success!",
          description: "Thank you for subscribing to our newsletter.",
        });
        setEmail('');
      } catch (error) {
        toast({
          title: "Error",
          description: "Failed to subscribe. Please try again.",
          variant: "destructive"
        });
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-2xl mx-auto px-4 text-center">
        <div className="mb-6">
          <Mail size={48} className="mx-auto text-gray-700" />
        </div>
        <h2 className="text-3xl font-light mb-4 text-gray-800">
          Let's Stay In Touch
        </h2>
        <p className="text-gray-600 mb-8">
          Subscribe to our email list for sneak peeks at design launches, early access to promotions, and Diamond Q Jewelers news!
        </p>
        <form onSubmit={handleSubmit} className="flex gap-4 max-w-md mx-auto">
          <Input
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="flex-1"
            disabled={loading}
          />
          <Button
            type="submit"
            className="bg-gray-900 hover:bg-gray-800 transition-colors"
            disabled={loading}
          >
            {loading ? 'Subscribing...' : 'Subscribe'}
          </Button>
        </form>
      </div>
    </section>
  );
};

export default Newsletter;